import type { CSSProperties } from 'react'
import { Outlet } from 'react-router-dom'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/layout/app-sidebar'
import { pacNavItems } from '@/components/layout/nav-config'

export function PolixAIV2Layout() {
  return (
    <SidebarProvider
      defaultOpen={false}
      style={
        {
          '--sidebar-width': '16rem',
          '--sidebar-width-icon': '2.5rem',
        } as CSSProperties
      }
    >
      <AppSidebar
        navItems={pacNavItems}
        currentApp="polix-ai"
      />
      <SidebarInset className="h-screen !min-h-0 overflow-hidden">
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  )
}
